<template>
  <div
    :class="[
      'add-new-popup z-[999] fixed transition-all inset-0 overflow-x-hidden overflow-y-auto lg:py-[20px]',
      { active: isOpen },
    ]"
  >
    <div
      class="popup-dialog flex transition-all max-w-[550px] min-h-full items-center mx-auto"
    >
      <div
        class="trezo-card w-full bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md max-h-[90vh] overflow-y-auto"
      >
        <div
          class="trezo-card-header bg-gray-50 dark:bg-[#15203c] mb-[20px] md:mb-[25px] flex items-center justify-between -mx-[20px] md:-mx-[25px] -mt-[20px] md:-mt-[25px] p-[20px] md:p-[25px] rounded-t-md"
        >
          <div class="trezo-card-title">
            <h5 class="mb-0">{{ directT('calendar.editEvent') }}</h5>
          </div>
          <div class="trezo-card-subtitle">
            <button
              type="button"
              class="text-[23px] transition-all leading-none text-black dark:text-white hover:text-primary-500"
              @click="closeModal"
            >
              <i class="ri-close-fill"></i>
            </button>
          </div>
        </div>
        <div class="trezo-card-content">
          <div v-if="error" class="mb-4 p-3 bg-red-100 text-red-700 rounded-md">
            {{ error }}
          </div>
          <form @submit.prevent="updateEvent">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-[15px] sm:gap-[25px]">
              <div class="col-span-1 sm:col-span-2">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('calendar.title') }}
                </label>
                <input
                  type="text"
                  v-model="formData.title"
                  required
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  :placeholder="directT('calendar.addTitle')"
                />
              </div>
              <div class="col-span-1">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('calendar.startDateTime') }}
                </label>
                <input
                  type="datetime-local"
                  v-model="formData.startTime"
                  required
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                />
              </div>
              <div class="col-span-1">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('calendar.endDateTime') }}
                </label>
                <input
                  type="datetime-local"
                  v-model="formData.endTime"
                  required
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                />
              </div>
              
              <div class="col-span-1">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('calendar.type') }}
                </label>
                <select
                  v-model="formData.eventType"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                >
                  <option value="">{{ directT('calendar.selectType') }}</option>
                  <option value="meeting">{{ directT('calendar.meeting') }}</option>
                  <option value="call">{{ directT('calendar.call') }}</option>
                  <option value="appointment">{{ directT('calendar.appointment') }}</option>
                  <option value="reminder">{{ directT('calendar.reminder') }}</option>
                  <option value="other">{{ directT('calendar.other') }}</option>
                </select>
              </div>
              
              <div class="col-span-1">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('calendar.customerName') }}
                </label>
                <input
                  type="text"
                  v-model="formData.customerName"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  :placeholder="directT('calendar.enterName')"
                />
              </div>
              
              <div class="col-span-1">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('calendar.phoneNumber') }}
                </label>
                <input
                  type="tel"
                  v-model="formData.phone"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  :placeholder="directT('calendar.enterPhoneNumber')"
                />
              </div>
              
              <div class="col-span-1">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('calendar.location') }}
                </label>
                <input
                  type="text"
                  v-model="formData.location"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  :placeholder="directT('calendar.enterLocation')"
                />
              </div>
              
              <div class="col-span-1 sm:col-span-2">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('calendar.description') }}
                </label>
                <textarea
                  v-model="formData.description"
                  class="h-[110px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] py-[15px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  :placeholder="directT('calendar.enterDescription')"
                ></textarea>
              </div>
            </div>
            <div class="mt-[25px] text-right flex justify-between">
              <button
                type="button"
                class="rounded-md inline-block transition-all font-medium px-[20px] sm:px-[26.5px] py-[12px] bg-danger-500 text-white hover:bg-danger-400"
                @click="deleteEvent"
                :disabled="isLoading"
              >
                {{ directT('calendar.delete') }}
              </button>
              <div>
                <button
                  type="button"
                  class="rounded-md inline-block transition-all font-medium mr-[15px] px-[20px] sm:px-[26.5px] py-[12px] bg-gray-500 text-white hover:bg-gray-400"
                  @click="closeModal"
                >
                  {{ directT('calendar.cancel') }}
                </button>
                <button
                  type="submit"
                  class="inline-block bg-primary-500 text-white py-[12px] px-[20px] sm:px-[26.5px] transition-all rounded-md hover:bg-primary-400"
                  :disabled="isLoading"
                >
                  <span class="inline-block relative pl-[25px]">
                    <i
                      class="material-symbols-outlined !text-[20px] absolute left-0 top-1/2 -translate-y-1/2"
                    >
                      save
                    </i>
                    {{ isLoading ? directT('calendar.saving') : directT('calendar.saveChanges') }}
                  </span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, defineExpose } from "vue";
import { supabase } from "@/lib/supabaseClient";
import { createToast } from "@/utils/toast";
import { useI18n } from "vue-i18n";
import enTranslations from "@/i18n/locales/en.json";
import heTranslations from "@/i18n/locales/he.json";
import arTranslations from "@/i18n/locales/ar.json";

// Type definition for translation objects
type TranslationObject = {
  [key: string]: string | TranslationObject;
};

const isOpen = ref(false);
const error = ref('');
const isLoading = ref(false);
const eventId = ref('');

// i18n setup
const { locale } = useI18n();

// Translation files
const translationFiles = {
  en: enTranslations,
  he: heTranslations,
  ar: arTranslations
};

// Direct translation function that bypasses vue-i18n
const directT = (key: string): string => {
  const parts = key.split('.');
  let result: TranslationObject = translationFiles[locale.value as keyof typeof translationFiles];
  
  for (const part of parts) {
    if (!result || !(part in result)) {
      console.warn(`Missing translation key: ${key} in ${locale.value} locale`);
      // Fallback to English if translation not found
      let enResult: TranslationObject = translationFiles.en;
      for (const fallbackPart of parts) {
        if (!enResult || !(fallbackPart in enResult)) return key;
        enResult = enResult[fallbackPart as keyof typeof enResult] as TranslationObject;
      }
      return typeof enResult === 'string' ? enResult : key;
    }
    result = result[part as keyof typeof result] as TranslationObject;
  }
  return typeof result === 'string' ? result : key;
};

const formData = reactive({
  title: '',
  startTime: '',
  endTime: '',
  eventType: '',
  customerName: '',
  phone: '',
  location: '',
  description: ''
});

// Show modal and load event data
function openModal(event: any) {
  // Format datetime to work with input type datetime-local
  const formatDateForInput = (dateStr: string | Date) => {
    if (!dateStr) return '';
    
    // Convert to string if it's a Date object
    const dateString = typeof dateStr === 'string' 
      ? dateStr 
      : dateStr instanceof Date 
        ? dateStr.toISOString() 
        : String(dateStr);
    
    // Handle ISO date strings
    if (dateString.includes('T')) {
      // Simply extract the YYYY-MM-DDTHH:MM part without any conversion
      // This preserves the exact time for editing
      return dateString.substring(0, 16);
    }
    
    // Fallback for non-ISO strings
    const date = new Date(dateString);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}T${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
  };

  // Set form data from event
  eventId.value = event.id;
  formData.title = event.title;
  formData.startTime = formatDateForInput(event.start);
  formData.endTime = formatDateForInput(event.end);
  formData.eventType = event.extendedProps?.eventType || '';
  formData.customerName = event.extendedProps?.customerName || '';
  formData.phone = event.extendedProps?.phone || '';
  formData.location = event.extendedProps?.location || '';
  formData.description = event.extendedProps?.description || '';
  
  // Open modal
  isOpen.value = true;
}

// Close modal
function closeModal() {
  isOpen.value = false;
  resetFormErrors();
}

// Reset form errors
function resetFormErrors() {
  error.value = '';
}

// Update event
async function updateEvent() {
  try {
    isLoading.value = true;
    error.value = '';

    // Validate required fields
    if (!formData.title || !formData.startTime || !formData.endTime) {
      error.value = 'Please fill in all required fields';
      return;
    }

    // Validate end time is after start time
    if (new Date(formData.endTime) <= new Date(formData.startTime)) {
      error.value = 'End date and time must be after start date and time';
      return;
    }

    // Format dates to store the exact time as entered by user without timezone conversion
    const formatDateForStorage = (dateTimeStr: string) => {
      // Store the exact format the user entered
      // This ensures no timezone shifting happens
      
      // Create a formatted string in the format Supabase expects
      // but ensure the time component exactly matches what the user entered
      const [datePart, timePart] = dateTimeStr.split('T');
      
      // Return a properly formatted string that preserves the exact time
      // Adding Z to explicitly mark it as UTC to prevent browser conversions
      return `${datePart}T${timePart}:00.000Z`;
    };

    // Update event in database
    const { data, error: updateError } = await supabase
      .from('calendar_events')
      .update({
        title: formData.title,
        start_time: formatDateForStorage(formData.startTime),
        end_time: formatDateForStorage(formData.endTime),
        event_type: formData.eventType || null,
        customer_name: formData.customerName || null,
        phone: formData.phone || null,
        location: formData.location || null,
        description: formData.description || null
      })
      .eq('id', eventId.value)
      .select();

    if (updateError) throw updateError;

    // Show success message
    createToast('Event updated successfully', 'success');
    
    // Close modal and notify
    closeModal();
    window.dispatchEvent(new CustomEvent('calendar-event-updated', { detail: data[0] }));
    
  } catch (err: any) {
    console.error('Error updating event:', err);
    error.value = err.message || 'Error updating event';
  } finally {
    isLoading.value = false;
  }
}

// Delete event
async function deleteEvent() {
  if (!confirm('Are you sure you want to delete this event?')) {
    return;
  }

  try {
    isLoading.value = true;
    error.value = '';

    const { error: deleteError } = await supabase
      .from('calendar_events')
      .delete()
      .eq('id', eventId.value);

    if (deleteError) throw deleteError;

    // Show success message
    createToast('Event deleted successfully', 'success');
    
    // Close modal and notify
    closeModal();
    window.dispatchEvent(new CustomEvent('calendar-event-deleted', { detail: { id: eventId.value } }));
    
  } catch (err: any) {
    console.error('Error deleting event:', err);
    error.value = err.message || 'Error deleting event';
  } finally {
    isLoading.value = false;
  }
}

// Expose methods to parent component
defineExpose({
  openModal
});
</script> 